import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'
import store from "@/store";

Vue.use(VueRouter)

function goTop() {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
}

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/index.vue'),
        name: 'Index',
        meta: { title: '首页' }
      },
      {
        path: 'query',
        component: () => import('@/views/query/index.vue'),
        name: 'query',
        meta: { title: '酒店查询'}
      },
      {
        path: 'details',
        component: () => import('@/views/hotelDetails/index.vue'),
        name: 'details',
        meta: { title: '酒店详情'}
      },
      {
        path: 'hotel-order',
        component: () => import('@/views/hotelOrder/index.vue'),
        name: 'hotel-order',
        meta: { title: '订单详情'}
      },
      {
        path: 'orderFromInfo',
        component: () => import('@/views/orderForm/orderFormInfo.vue'),
        name: 'orderFromInfo',
        meta: { title: '酒店详情'}
      },
      {
        path: 'selfHotel',
        component: () => import('@/views/selfHotel/index.vue'),
        name: 'selfHotel',
        meta: { title: '自营酒店'}
      },
      {
        path: 'ticket',
        component: () => import('@/views/ticket/index.vue'),
        name: 'ticket',
        meta: { title: '车票预定'}
      },
      {
        path: 'enter',
        component: () => import('@/views/ticket/enter.vue'),
        name: 'enter',
        meta: { title: '录入信息'}
      },
      {
        path: 'enterReturn',
        component: () => import('@/views/ticket/enterReturn.vue'),
        name: 'enterReturn',
        meta: { title: '往返录入信息'}
      },
      {
        path: 'ticket-submit-order-return',
        component: () => import('@/views/ticket/submitOrderReturn.vue'),
        name: 'ticket-submit-order-return',
        meta: { title: '提交往返订单页面'}
      },
      {
        path: 'ticket-submit-order',
        component: () => import('@/views/ticket/submitOrder.vue'),
        name: 'ticket-submit-order',
        meta: { title: '提交订单页面'}
      },
      {
        path: 'ticket-order-pay-return',
        component: () => import('@/views/ticket/orderPayReturn.vue'),
        name: 'ticket-order-pay-return',
        meta: { title: '车票往返订单支付页面'}
      },
      {
        path: 'ticket-order-pay',
        component: () => import('@/views/ticket/orderPay.vue'),
        name: 'ticket-order-pay',
        meta: { title: '车票订单支付页面'}
      },
      {
        path: 'order',
        component: () => import('@/views/orderForm/index.vue'),
        name: 'order',
        meta: { title: '订单列表'}
      },
      {
        path: 'order-info',
        component: () => import('@/views/orderInfo/index.vue'),
        name: 'order-info',
        meta: { title: '支付'}
      },
      {
        path: 'ticket-order-detail',
        component: () => import('@/views/ticket/orderDetail.vue'),
        name: 'ticket-order-detail',
        meta: { title: '订单详情'}
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach( function( to , from , next) {
    if( to.path !== '/index'){
      store.commit('setBgColor', '#F5F7FA');
      store.commit('setBgImg', false);
      goTop();
      next();
    } else {
      store.commit('setBgColor', 'none');
      store.commit('setBgImg', true);
      goTop();
      next();
    }
  goTop();
  next()
})

export default router
